
<!--
    Element responsible for communication between its nested nodes
    tracks a primary nested state (usually a cards component) that will be responsible for all the changes off all other inferior nested states
-->

<script>
    export default {
        name: "ContextWrapperElement",
        data () {
            return {
                elementType: "context-wrapper",
                givesContextToChildren: true,
                primaryNodeTypes : {
                    "course-cards" : "course-cards-wrapper",
                    "bundle-cards" : "bundle-cards-wrapper",
                    "subscription-cards" : "subscription-cards-wrapper",
                    "blog-post-cards" : "blog-post-cards-wrapper",
                    "daily-news-cards" : "daily-news-cards-wrapper",
                    "community-post-cards" : "community-post-cards-wrapper",
                    "course-contents" : "course-contents-wrapper"
                }
            }
        },
        computed : {
            getPrimaryNodeId () {
                return this.nestedComponentIds.find( componentId => {
                    let nestedNodeState = this.findNodeState(componentId);
                    return  nestedNodeState && nestedNodeState.componentType && this.primaryNodeTypes[nestedNodeState.componentType] ? nestedNodeState.myId : "";
                })
            },
            getPrimaryNodeState () {
                return this.findNodeState(this.getPrimaryNodeId);
            },
            contextWrapperType () {
                return this.getPrimaryNodeState && this.primaryNodeTypes[this.getPrimaryNodeState.myNodeType] ? this.primaryNodeTypes[this.getPrimaryNodeState.myNodeType] : "";
            },
        },
        methods: {
            getNestedComponentState (componentType) {
                let compId = this.nestedComponentIds.find( componentId => {
                    let nestedNodeState = this.findNodeState(componentId);
                    return nestedNodeState && nestedNodeState.componentType && nestedNodeState.componentType  === componentType;
                })

                return this.findNodeState(compId);
            }
        }
    }
</script>

